const TICKET_IMAGE_PREVIEW_TYPES = new Set([
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
]);

interface TicketImagePreviewEntry {
  url: string | null;
  failed: boolean;
}

export class TicketImagePreviewCache {
  private readonly entries = new Map<File, TicketImagePreviewEntry>();

  sync(files: readonly File[]): void {
    const retainedFiles = new Set(
      files.filter((file) => TICKET_IMAGE_PREVIEW_TYPES.has(file.type.toLowerCase())),
    );

    for (const [file, entry] of this.entries) {
      if (retainedFiles.has(file)) continue;
      this.revoke(entry.url);
      this.entries.delete(file);
    }

    for (const file of retainedFiles) {
      if (this.entries.has(file)) continue;
      try {
        this.entries.set(file, {
          url: URL.createObjectURL(file),
          failed: false,
        });
      } catch {
        this.entries.set(file, { url: null, failed: true });
      }
    }
  }

  urlFor(file: File): string | null {
    const entry = this.entries.get(file);
    return entry && !entry.failed ? entry.url : null;
  }

  markFailed(file: File): void {
    const entry = this.entries.get(file);
    if (!entry || entry.failed) return;
    this.revoke(entry.url);
    this.entries.set(file, { url: null, failed: true });
  }

  clear(): void {
    for (const entry of this.entries.values()) {
      this.revoke(entry.url);
    }
    this.entries.clear();
  }

  private revoke(url: string | null): void {
    if (url) URL.revokeObjectURL(url);
  }
}
